import React from 'react';
import type { ResumeData } from '../types';
import { formatDate } from '../utils';

export function ProfessionalTemplate({ data }: { data: ResumeData }) {
  return (
    <div className="max-w-4xl mx-auto bg-white p-8">
      {/* Header */}
      <header className="bg-gray-900 text-white p-8 -mx-8 -mt-8 mb-8">
        <h1 className="text-4xl font-bold mb-4">{data.personalInfo.fullName}</h1>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-sm">
          <div>{data.personalInfo.email}</div>
          <div>{data.personalInfo.phone}</div>
          <div>{data.personalInfo.location}</div>
          {data.personalInfo.website && <div>{data.personalInfo.website}</div>}
        </div>
      </header>

      {/* Experience */}
      <section className="mb-8">
        <h2 className="text-2xl font-bold text-gray-900 border-b-2 border-gray-900 pb-2 mb-4">
          Professional Experience
        </h2>
        {data.experiences.map((exp) => (
          <div key={exp.id} className="mb-6">
            <div className="flex justify-between items-start mb-2">
              <div>
                <h3 className="text-xl font-semibold text-gray-900">{exp.position}</h3>
                <h4 className="text-lg text-gray-700">{exp.company}</h4>
              </div>
              <div className="text-gray-600">
                {formatDate(exp.startDate)} - {exp.isCurrentJob ? 'Present' : formatDate(exp.endDate)}
              </div>
            </div>
            <p className="text-gray-700">{exp.description}</p>
          </div>
        ))}
      </section>

      {/* Education */}
      <section className="mb-8">
        <h2 className="text-2xl font-bold text-gray-900 border-b-2 border-gray-900 pb-2 mb-4">
          Education
        </h2>
        {data.education.map((edu) => (
          <div key={edu.id} className="mb-4">
            <div className="flex justify-between items-start">
              <div>
                <h3 className="text-xl font-semibold text-gray-900">{edu.degree}</h3>
                <h4 className="text-lg text-gray-700">{edu.institution}</h4>
              </div>
              <div className="text-gray-600">
                {formatDate(edu.startDate)} - {edu.isPursuing ? 'Present' : formatDate(edu.endDate)}
              </div>
            </div>
          </div>
        ))}
      </section>

      {/* Skills */}
      <section>
        <h2 className="text-2xl font-bold text-gray-900 border-b-2 border-gray-900 pb-2 mb-4">
          Skills & Expertise
        </h2>
        <div className="grid md:grid-cols-2 gap-6">
          <div>
            <h3 className="text-lg font-semibold mb-2">Technical Skills</h3>
            <p className="text-gray-700">{data.skills.technical}</p>
          </div>
          <div>
            <h3 className="text-lg font-semibold mb-2">Soft Skills</h3>
            <p className="text-gray-700">{data.skills.soft}</p>
          </div>
        </div>
      </section>
    </div>
  );
}